<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderOrders',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  { id: 'orders', text: 'Orders', to: AppRoute.Orders, disabled: true },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
